import { useState } from 'react';

import ChevronDownIcon from '@/assets/icons/chevron-down.svg';
import { useOpening } from '@/components/pages/job-posting/use-opening';
import { Separator } from '@/components/ui/separator';
import { Typography } from '@/components/ui/typography';
import { useCurrencySymbol } from '@/hooks/use-currency-symbol';
import { cn } from '@/utils/classnames';

import { ChannelRow } from './channel-row';

interface OpeningRowProps {
  openingId: string;
}

export function OpeningRow({ openingId }: OpeningRowProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { formatCurrency } = useCurrencySymbol();
  const { title, selectedChannels, totalBudget } = useOpening(openingId);

  // Hide openings with no channels selected
  if (selectedChannels.length === 0) return null;

  return (
    <li className="bg-fx-neutral-50 border-fx-neutral-100 flex flex-col rounded-lg border">
      <button
        type="button"
        onClick={() => setIsExpanded(prev => !prev)}
        className="hover:bg-fx-neutral-100 flex items-center justify-between gap-2 rounded-t-lg p-3"
      >
        {/* Opening name */}
        <Typography variant="body2" className="min-w-0 truncate">
          {title}
        </Typography>

        <div className="flex shrink-0 items-center gap-2">
          {/* Total opening budget */}
          <Typography
            variant="subtitle1"
            className="text-fx-neutral-900 font-bold"
          >
            {formatCurrency(totalBudget)}
          </Typography>

          {/* Expand/collapse icon */}
          <img
            src={ChevronDownIcon}
            alt=""
            className={cn(
              'size-3 transition-transform',
              isExpanded && 'rotate-180',
            )}
          />
        </div>
      </button>

      {isExpanded && (
        <>
          <div className="mx-3">
            <Separator />
          </div>

          <ul className="flex flex-col gap-2 p-3">
            {selectedChannels.map(channel => (
              <ChannelRow
                key={`${openingId}-${channel.slug}`}
                channel={channel}
                openingId={openingId}
              />
            ))}
          </ul>
        </>
      )}
    </li>
  );
}
